export default "assets/images/icons/star-04dff923.svg";